import { render, staticRenderFns } from "./risk-advisor-teams.vue?vue&type=template&id=71a7c665&"
import script from "./risk-advisor-teams.vue?vue&type=script&lang=js&"
export * from "./risk-advisor-teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a7c665')) {
      api.createRecord('71a7c665', component.options)
    } else {
      api.reload('71a7c665', component.options)
    }
    module.hot.accept("./risk-advisor-teams.vue?vue&type=template&id=71a7c665&", function () {
      api.rerender('71a7c665', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/risk-advisor-teams.vue"
export default component.exports